module.exports = __webpack_public_path__ + "assets/d14b3fcea240f9d2caa964aa70441679.png";